__turbopack_context__.v({
  "category_name": "OBuG1G_category_name",
  "item": "OBuG1G_item",
  "item_info": "OBuG1G_item_info",
  "item_info_contact": "OBuG1G_item_info_contact",
  "item_info_meta": "OBuG1G_item_info_meta",
  "item_info_name": "OBuG1G_item_info_name",
  "item_info_note": "OBuG1G_item_info_note",
  "item_info_tags": "OBuG1G_item_info_tags",
  "item_popup_content": "OBuG1G_item_popup_content",
  "list": "OBuG1G_list",
  "title": "OBuG1G_title",
});
